import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    background: '#f7f7f7',
    borderBottom: '1px solid rgba(112, 112, 112, .3)',
  },
  icon: {
    fontSize: '1.4rem',
    color: '#666',
  },
  label: {
    marginLeft: 5,
    fontSize: 15,
    color: theme.custom.darkBlue,
  },
}));
